
<template>
	<div id="app">
        
		<transition name="fade"
		            mode="out-in">
			<router-view></router-view>
		</transition>
        
	</div>
</template>


<script>
export default {
    name: 'App',
    watch: {
        '$route': function(to,from){
    　      document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        }
    },
    data () {
        return {
            // imgPath: '//tp-app.oss-cn-hangzhou.aliyuncs.com/website/'
        }
    }

}
</script>

<style >
body {
    margin: 0;
}
* {
    margin: 0;
    padding: 0;
}
.flex {
    display: flex;
}
div, section, p {
    box-sizing: border-box;
}
a {
    text-decoration: none;
    /* color: #666666; */
}
#app {
    font-family: PingFangSC,PingFang SC;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #373636;
    margin-top: 0;
    position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue